import { render, staticRenderFns } from "./CreateProcessDialog.vue?vue&type=template&id=6b3c2b1c"
import script from "./CreateProcessDialog.vue?vue&type=script&lang=js"
export * from "./CreateProcessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports